import { removeUserManager } from "./authentication-service.js";
let userRequested = false;
let numberAuthentication = 0;

const isRequireSignin = (oidcUser, isForce) => isForce || !oidcUser;

export const authenticateUser = function (userManager, location, history) {
  let user = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
  return async function () {
    let isForce = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    let callbackPath = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    const oidcUser = user !== null ? user : await userManager.getUser();

    if (userRequested) {
      return;
    }

    numberAuthentication++;
    const url = callbackPath || location.pathname + (location.search || '');

    if (isRequireSignin(oidcUser, isForce)) {
      userRequested = true;

      try {
        await userManager.signinRedirect({
          data: {
            url
          }
        });
      } catch (error) {
        removeUserManager();
        throw error;
      } finally {
        userRequested = false;
      }
    } else if (oidcUser !== null && oidcUser !== void 0 && oidcUser.expired) {
      userRequested = true;

      try {
        await userManager.signinSilent();
      } catch (error) {
        if (numberAuthentication <= 1) {
          await userManager.signinRedirect({
            data: {
              url
            }
          });
        } else {
          userRequested = false;
          history.push(`/authentication/session-lost?path=${encodeURI(url)}`);
        }
      }

      userRequested = false;
    }
  };
};
export const logoutUser = async userManager => {
  const oidcUser = await userManager.getUser();

  if (oidcUser) {
    await userManager.signoutRedirect();
  }
};
//# sourceMappingURL=oidc-service.js.map